module.exports = __webpack_public_path__ + "static/media/IMG_1248-min.a340a08c.jpg";